// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"4a68c3c7","206":"b15f4c39","255":"b6565670","780":"54c55107"}[chunkId] + ".chunk.css";
};